import { useLocation, type RouteSectionProps } from "@solidjs/router";
import { Show, onMount, type ParentComponent } from "solid-js";
import { AuthProvider, useAuth } from "./stores/auth";
import BottomNav from "./components/BottomNav";
import StreakUpdateOverlay from "./components/StreakUpdateOverlay";
import TelegramChrome from "./components/TelegramChrome";
import LoginPage from "./pages/LoginPage";
import { t } from "./i18n";
import {
  showSessionCelebration,
  showStreakCelebration,
} from "./lib/streakCelebration";

const Shell: ParentComponent = (props) => {
  const location = useLocation();
  const hideNav = () => location.pathname.startsWith("/workouts/active");
  const home = () => location.pathname === "/";

  return (
    <div
      class={`app-shell mx-auto w-full max-w-lg${
        hideNav() ? " app-shell--immersive" : ""
      }`}
    >
      <main class={`app-main${home() ? " app-main--home" : ""}`}>
        {props.children}
      </main>
      <Show when={!hideNav()}>
        <BottomNav />
      </Show>
    </div>
  );
};

function AuthenticatedRoot(props: RouteSectionProps) {
  const auth = useAuth();

  onMount(() => {
    const ritual = new URLSearchParams(window.location.search).get("ritual");
    if (ritual === "session") showSessionCelebration(45, "");
    else if (ritual) {
      const n = Number(ritual);
      if (Number.isFinite(n) && n > 0) showStreakCelebration(Math.max(0, n - 1), n);
      else showStreakCelebration(2, 3);
    }
  });

  return (
    <>
      <TelegramChrome />
      <Show
        when={!auth.loading()}
        fallback={
          <div class="relative flex min-h-dvh items-center justify-center">
            <p class="relative z-[1] text-[15px] text-ink-muted">
              {t("LOADING")}
            </p>
          </div>
        }
      >
        <Show when={auth.authenticated()} fallback={<LoginPage />}>
          <Shell>{props.children}</Shell>
        </Show>
      </Show>
      <StreakUpdateOverlay />
    </>
  );
}

export default function App(props: RouteSectionProps) {
  return (
    <AuthProvider>
      <AuthenticatedRoot {...props} />
    </AuthProvider>
  );
}
